import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Pest from "../components/PestList";


const UsersListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      {/* <MasterLayout> */}

        {/* Breadcrumb */}
        <Breadcrumb title="Pest" />

        {/* UsersListLayer */}
        <Pest />

      {/* </MasterLayout> */}

    </>
  );
};

export default UsersListPage; 
